/**
 * @desc       General account helpers
 * @version     1.0 - 27 Mar 202 **/

export function tenantFromPathname() {
    try {
        const wlp = window.location.pathname
        return wlp.split('/').filter(Boolean)[0] || null
    } catch (error) {
        console.error('Error extracting tenant from pathname:', error)
        return null
    }
}
